import {
  Children,
  cloneElement,
  isValidElement,
  ReactElement,
  ReactNode,
} from 'react';

export function applyDataTestIdToChildren<T>(
  children: ReactNode,
  componentType: React.ComponentType<T>,
  name: string,
  postfix: string,
  propName: 'value' | 'children' = 'value',
): any {
  const newChildren: ReactNode[] = [];

  // using .forEach(), since .map() changes the keys of children and it causes issues
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === componentType) {
      const childValue = child.props[propName];
      const newChild = cloneElement(child as ReactElement, {
        'data-test-id': `${name}-${childValue}-${postfix}`,
        'data-override-id': 'sitecoreOutlineOverride', // overrides the default styles
      });
      newChildren.push(newChild);
    } else {
      newChildren.push(child);
    }
  });

  return newChildren;
}
